// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
  // var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
  if ($(".obj_image").length > 0) {
    objectFitImages(".obj_image");
  }
});

// ヘッダーの背景追加
jQuery(function ($) {
  var $header = $(".header");
  if ($(window).width() >= 1000) {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 120) {
        $header.addClass("scroll");
      } else {
        $header.removeClass("scroll");
      }
    });
  }
  if ($(window).width() < 1000) {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 50) {
        $header.addClass("scroll");
      } else {
        $header.removeClass("scroll");
      }
    });
  }
});

// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function ($) {
  if ($(".js-image-switch").length > 0) {
    var $elem = $(".js-image-switch");
    var sp = "_sp.";
    var pc = "_pc.";
    // 画像を切り替えるウィンドウサイズ // Window size to switch images
    var replaceWidth = 768;

    function imageSwitch() {
      var windowWidth = parseInt($(window).width());
      $elem.each(function () {
        var $this = $(this);
        if (windowWidth >= replaceWidth) {
          $this.attr("src", $this.attr("src").replace(sp, pc));
        } else {
          $this.attr("src", $this.attr("src").replace(pc, sp));
        }
      });
    }
    imageSwitch();

    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        imageSwitch();
      }, 200);
    });
  }
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($("dl.accordion dt").length > 0) {
    $("dl.accordion dt").click(function () {
      $(this).next("dd").slideToggle();
      $(this).toggleClass("open");
    });
  }
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function ($) {
  if ($("#pageplugin").length > 0) {
    var windowWidth = $(window).width();
    var htmlStr = $("#pageplugin").html();
    var timer = null;
    $(window).on("resize", function () {
      var resizedWidth = $(window).width();
      if (windowWidth != resizedWidth && resizedWidth < 500) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          $("#pageplugin").html(htmlStr);
          window.FB.XFBML.parse();
          //window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
          var windowWidth = $(window).width();
        }, 500);
      }
    });
  }
});

//swiper
const swiper = new Swiper(".merit-swiper", {
  loop: true, // ループ有効
  speed: 8000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  spaceBetween: 28,
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});
const staffSwiper = new Swiper(".top-staff-swiper", {
  loop: true, // ループ
  spaceBetween: 25,
  loopAdditionalSlides: 1,
  slidesPerView: 1, // 一度に表示する枚数
  loopedSlides: 3,
  navigation: {
    //ナビゲーション（矢印）
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    569: {
      slidesPerView: 2,
    },
    769: {
      slidesPerView: 3,
    },
  },
});
const newsSwiper = new Swiper(".top-news-swiper", {
  loop: true, // ループ有効
  speed: 8000, // ループの時間
  spaceBetween: 20,
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});
const reasonSwiper = new Swiper(".reason-example-swiper", {
  loop: true, //ループ
  spaceBetween: 30,
  slidesPerView: 2,
  loopedSlides: 3,
  loopAdditionalSlides: 4,
  centeredslides: true,
  autoplay: {
    //自動再生
    delay: 4000,
  },
  navigation: {
    //ナビゲーション（矢印）
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    569: {
      slidesPerView: 3,
    },
    769: {
      slidesPerView: 3.5,
    },
  },
});
const serviceSwiper = new Swiper(".service-example-swiper", {
  loop: true, //ループ
  spaceBetween: 20,
  slidesPerView: 2,
  loopedSlides: 3,
  centeredslides: true,
  loopAdditionalSlides: 1,
  speed: 6000, // ループの時間
  autoplay: {
    //自動再生
    delay: 0,
  },
  breakpoints: {
    569: {
      slidesPerView: 3,
    },
    1001: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});

// タッチデバイス
const isTouchDevice = window.ontouchstart !== undefined;
let touchDeviceHoverElement;
const touch = document.getElementsByClassName("touch");
for (i = 0; i < touch.length; i++) {
  touch[i].addEventListener("click", (e) => {
    if (isTouchDevice) {
      if (touchDeviceHoverElement !== e.target) {
        touchDeviceHoverElement = e.target;
        e.preventDefault();
      }
    }
  });
}
